import React from "react";
import styles from "../css/scanModeSwitch.module.css";

export default function ScanModeSwitch({ entryMode, setEntryMode }) {
  const checked = entryMode === "Scan";

  const handleToggle = () => {
    setEntryMode(checked ? "Manual" : "Scan");
  };

  return (
    <button
      type="button"
      className={styles.switchContainer}
      onClick={handleToggle}
      aria-pressed={checked}
      aria-label="Toggle scan mode"
    >
      <span className={styles.label}>Scan</span>
      <span className={`${styles.switch} ${checked ? styles.switchOn : styles.switchOff}`}>
        <span className={styles.knob} />
      </span>
    </button>
  );
}

